// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Assets Area
export class AreaAssets {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /** Fetches all remote assets in the version
     * @param from - Remote version to fetch from
     * @returns All assets in the specified version
     */
    async getAssets(from) {
        return this.dataCore.assets(from.designSystemId, from.versionId);
    }
    /** Fetches all remote asset groups in the version
     * @param from - Remote version to fetch from
     * @returns All asset groups in the specified version
     */
    async getAssetGroups(from) {
        return this.dataCore.assetGroups(from.designSystemId, from.versionId);
    }
    /** Renders all assets in this version and retrieves URLs from which assets can be downloaded as key-value.
     *
     * You can only render one combination of size/format with one request - use more requests if you need to render more. Assets that are rendered as "png" will use "scale" attribute, however, when the format is "svg" or "pdf", scale attribute is ignored and will always render the original size.
     *
     * Note that assets are not persistent and URLs will expire quickly - you must download them and store them locally / remotely and can never use this URL publicly as it won't work after a short time
     * @param from - Remote version to fetch from
     * @param assets - Assets to render
     * @param groups - All asset groups in the version
     * @param format - Format to render (png, svg, pdf)
     * @param scale - Scale to render (1x, 2x, 3x, 4x)
     * @returns All assets that were provided in the request, rendered in the specified format and scale
     */
    async getRenderedAssets(from, assets, groups, format, scale) {
        // Construct rendering request. Only one size can be rendered at once
        const settings = [
            {
                format,
                scale,
                prefix: "",
                suffix: "",
            },
        ];
        return this.dataCore.renderedAssets(from.designSystemId, from.versionId, assets, groups, settings);
    }
    /** Renders figma frames based on the source and node id. The result is a URL to the hosted image of the Figma frame that is stable across updates.
     *
     * @returns Rendered Figma frames
     */
    async getRenderedFigmaFramesAsync(from, nodesToRender) {
        return this.dataCore.renderedFigmaFramesAsync(from.designSystemId, from.versionId, nodesToRender);
    }
}
